import { render, staticRenderFns } from "./InputNumerc.vue?vue&type=template&id=5fbd72a0&"
import script from "./InputNumerc.vue?vue&type=script&lang=js&"
export * from "./InputNumerc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports